























import { Component, Watch, Mixins, Inject } from 'vue-property-decorator';
import { InnerMenu } from '@/pages/profile/blocks';
import { Button } from '@/pages/profile/components';
import Infotext from '@/components/parts/infotext';
import { PopupData } from '../../programcard';
import { programsRoutes } from '../../router';
import {
  LoaderMixin,
  StatusEnum,
  IsChildApprovedMixin,
} from '@/pages/profile/mixins';
import { mentoringService } from '@/services';
import { AxiosInstance, Programs, Routes, IMentoringPrograms } from './types';

@Component({
  components: {
    Button,
    Infotext,
    InnerMenu,
  },
})
export default class MentoringPrograms
  extends Mixins(LoaderMixin, IsChildApprovedMixin)
  implements IMentoringPrograms {
  @Inject() $api: AxiosInstance;

  public innerMenu: Routes = programsRoutes;
  public errorMessage: string = '';
  public programs: Programs = [];

  get tutoredId(): string {
    return this.id ? this.childTutoredId(this.id) : '';
  }

  @Watch('id', { immediate: true })
  updateData(): void {
    this.reset();
    this.getData();
  }

  reset(): void {
    this.programs = [];
    this.closeMessages();
  }

  closeMessages() {
    this.errorMessage = '';
    this.status = StatusEnum.SUCCESS;
  }

  async getData(): Promise<void> {
    const { $api, tutoredId, isApproved } = this;
    if (!this.isApproved || !tutoredId) return;

    this.status = StatusEnum.LOADING;

    try {
      const { data } = await mentoringService($api).getPrograms(tutoredId);
      this.programs = data;
      this.status = StatusEnum.SUCCESS;
    } catch (err) {
      if (err.response.data && err.response.data.errors) {
        const [{ msg }] = err.response.data.errors;
        this.errorMessage = msg;
      }
      this.status = StatusEnum.ERROR;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/views/programs/MentoringPrograms.vue